module.exports = __webpack_public_path__ + "img/map_Z2.5.B.03.62dad87a.svg";